import * as React from 'react'
import Select from 'react-select'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import Close from '../../icons/vehicle/Close'
import {
  IMap,
  IProviderObject,
  IProviderProductObject,
  IUpdateVehicleProviderProducts,
  IVehicleObj
} from '../../../types'
import EditBottom from '../../vehicles/edit-vehicle/EditBottom'

interface IEditProductsPaneProps extends RouteComponentProps<{ id: string }> {
  createEditVehicleRequest: boolean
  createEditVehicle: any
  createEditVehicleError: string
  isRequesting: boolean
  products: IProviderProductObject[]
  vehicle: IVehicleObj
  nextStep: string
  isSaved: boolean
  organizationId: string
  allProducts: IProviderProductObject[]
  setVehicleSavedStateToInitial: () => void
  updateVehicleProviderProducts: (data: IUpdateVehicleProviderProducts) => void
  getVehicleById: (id: string) => void
  fetchProductsByOrganizationId: (organizationId: string) => void
  currentVehicle: IVehicleObj
}

interface IEditProductsPaneState {
  selectedProviders: IProviderObject[]
  selectedProducts: IProviderProductObject[]
  addedProducts: IProviderProductObject[]
  isSaved: boolean
  isSaving: boolean
}

class EditProductsPane extends React.Component<IEditProductsPaneProps, IEditProductsPaneState> {
  public state: IEditProductsPaneState = {
    selectedProviders: [],
    selectedProducts: [],
    addedProducts: [],
    isSaved: false,
    isSaving: false
  }

  public componentDidMount() {
    this.props.getVehicleById(this.props.match.params.id)
    this.initSelectedDataOnPropsChanged()
  }

  public componentWillMount() {
    this.props.setVehicleSavedStateToInitial()
    this.props.fetchProductsByOrganizationId(this.props.organizationId)
  }

  public handleSubmit = () => {
    // copy the selected products (addedProducts) to the product list (selectedProducts)
    this.state.addedProducts.map(newProduct => {
      this.state.selectedProducts.push(newProduct)
    })

    this.props.updateVehicleProviderProducts({
      id: this.props.match.params.id,
      providerProductsIds: this.state.selectedProducts.map(it => it.id)
    })

    this.setState({
      isSaved: true
    })
  }

  public componentDidUpdate(prevProps: IEditProductsPaneProps) {
    if (JSON.stringify(prevProps.vehicle) !== JSON.stringify(this.props.vehicle)) {
      this.initSelectedDataOnPropsChanged()
    }
    if (this.props.isSaved) {
      this.props.history.push(`/vehicles/view/${prevProps.vehicle.id}/products`)
    }
  }

  public render() {
    const { isSaved, isSaving } = this.state

    if (this.props.createEditVehicleRequest || !this.props.vehicle) {
      return <div> Wait </div>
    }
    if (!this.props.createEditVehicle && !this.props.createEditVehicleRequest) {
      return <Redirect to={'/vehicles'} />
    }

    return (
      <div className='pt2'>
        <div className='col-7 ml3'>
          <div className='bold font-dark-grey'>Products</div>
          <div className='col-12 mb1 py1 pb2'>
            <div className='col-12 flex flex-wrap'>
              {this.state.selectedProducts.map((product: IProviderProductObject) => (
                <div className='mb1' key={product.id}>
                  <div className='flex items-center mr1 px1 border-light-grey4 rounded font-blue-grey'>
                    <span className='h6 mr1 '>{product.name}</span>
                    <button className='btn-transparent' onClick={this.handleRemoveProduct(product.id)}>
                      <Close />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className='mb1 mt2'>Add new product</div>
            <Select
              onChange={this.handleSelectProduct}
              options={this.getProductOptions()}
              isMulti={true}
              isClearable={true}
            />
          </div>
        </div>

        {isSaved ? (
          <div className='w100 p2 bg-green font-white bold fs-14 center border-box'>
            Vehicle {this.props.vehicle.make} {this.props.vehicle.model} has been successfully updated
          </div>
        ) : (
          <EditBottom
            isSaving={isSaving}
            cancelPath={`/vehicles/view/${this.props.vehicle.id}/products`}
            onSave={this.handleSubmit}
          />
        )}
      </div>
    )
  }

  private initSelectedDataOnPropsChanged() {
    if (this.props.vehicle) {
      this.setState({
        selectedProducts: this.props.vehicle.products
      })
    }
  }

  private handleSelectProduct = (productOptions: any[]) => {
    // note: new products will be added after the user clicks the next button
    // All selected products will be added temporarily in the addedProducts state
    // The user can select multiple products in the list

    // check if the user add some products
    if (productOptions !== null) {
      // there are at least 1 product in the list, copy the selected products to addedProducts state
      this.setState({ addedProducts: productOptions })
    } else {
      // there are no products in the list, clear the addedProducts state
      this.setState({ addedProducts: [] })
    }
  }

  private handleRemoveProduct = (productId: string) => (e: any) => {
    // remove the product from the list
    this.setState({ selectedProducts: this.state.selectedProducts.filter(it => it.id !== productId) })
  }

  private getProductOptions = () => {
    // return all products except for the added products
    return this.props.allProducts
      .filter(product => this.state.selectedProducts.every(it => product.id !== it.id))
      .map(product => ({
        id: product.id,
        label: product.name,
        value: product.name,
        product
      }))
  }
}

export default EditProductsPane



// WEBPACK FOOTER //
// ./src/components/vehicles/edit-vehicle/EditProductsPane.tsx